import { Capacitor } from '@capacitor/core';
import { PUBLIC_URL } from '../config';

const isNative = () => Capacitor.isNativePlatform();

function blobToBase64(b: Blob): Promise<string> {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(String(r.result).split(',')[1]);
    r.onerror = rej;
    r.readAsDataURL(b);
  });
}

/** Save/share the final strip. Android → system share sheet (Lưu vào Ảnh, Zalo, Messenger…). */
export async function saveImage(blob: Blob, filename: string) {
  if (isNative()) {
    const { Filesystem, Directory } = await import('@capacitor/filesystem');
    const { Share } = await import('@capacitor/share');
    const data = await blobToBase64(blob);
    const { uri } = await Filesystem.writeFile({ path: filename, data, directory: Directory.Cache });
    await Share.share({ title: 'Booth Together', files: [uri] });
    return;
  }
  const file = new File([blob], filename, { type: blob.type });
  if (navigator.canShare?.({ files: [file] }) && /Android|iPhone|iPad/i.test(navigator.userAgent)) {
    try {
      await navigator.share({ files: [file], title: 'Booth Together' });
      return;
    } catch { /* cancelled → fall back to download */ }
  }
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
}

export function inviteLink(code: string) {
  const base = isNative() ? PUBLIC_URL : location.origin + location.pathname;
  return base ? `${base.replace(/\?.*$/, '')}?room=${code}` : '';
}

export async function shareInvite(code: string) {
  const link = inviteLink(code);
  const text = `Vào chụp photobooth cùng mình nha 📸 Mã phòng: ${code}` +
    (link ? `\nWeb: ${link}` : '') + `\nApp: boothtogether://join?room=${code}`;
  if (isNative()) {
    const { Share } = await import('@capacitor/share');
    await Share.share({ title: 'Booth Together', text });
    return;
  }
  if (navigator.share) {
    try { await navigator.share({ text }); return; } catch { /* cancelled */ }
  }
  await navigator.clipboard?.writeText(link || code);
}
